<template>
  <div class="langPicker" :data-lang="locale">
    <a
      :href="`/en${currentRoute}`"
      v-bind:class="locale == 'en' ? 'active_locale' : ''"
      >EN</a
    >
    <span class="ml-1">/</span>
    <a
      :href="`/${defaultLang}${currentRoute}`"
      class="ml-1"
      v-bind:class="locale == defaultLang ? 'active_locale' : ''"
      >{{ defaultLang.toUpperCase() }}</a
    >
  </div>
</template>

<script>
export default {
  props: ['locale', 'defaultLang', 'currentRoute'],
};
</script>
